<template>
    <div>
        <el-drawer
            title="商品数据"
            :visible.sync="drawerShow"
            :wrapperClosable="true"
            :destroy-on-close="true"
            size="auto"
            @close="close"
        >
            <div class="drawer-content" v-loading="listLoading">
                <div>{{data && data.goodsName}}</div>
                <table class="info-table MT20" width="100%">
                    <tr>
                        <th>已支付数量</th>
                        <td>{{data && data.totalSellNum }}</td>
                    </tr>                    
                    <tr>
                        <th>待退款数量</th>
                        <td>{{data && data.pendingRefundNum }}</td>
                    </tr>
                    <tr>
                        <th>已退款数量</th>
                        <td>{{data && data.refundedNum}}</td>
                    </tr>
					<tr>
					    <th class="color-danger">有效销售数量</th>
					    <td>{{data.totalSellNum - data.pendingRefundNum - data.refundedNum }} <small><span>【已支付数量 - 待退款数量 - 已退款数量 = XX】</span></small></td>
					</tr>
                    <tr>
                        <th>已结算</th>
                        <td>{{data && data.totalSettleNum}}</td>
                    </tr>
                </table>
            </div>
            <div class="drawer-footer">
                <el-button size="medium" @click="close">关闭</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
export default {
    data(){
        return{
            drawerShow: false,
            listLoading:false,
            data: null
        }
    },
    methods:{
        close(){
            this.drawerShow = false
        },
        show(id){
            this.getData(id);
            this.drawerShow = true
        },
        getData(id){
            this.listLoading = true;
            this.$request({
                    url: '/shop_good/goodsSellData',
                    method: 'POST',
                    params: {id:id}
                }).then(res => {
                    const { state, msg, result } = res.data;
                    if( state == 1 && result ){
                        this.data = result || null;
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>